import React, { useState } from "react";
import Textinput from "@/components/ui/Textinput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useRouter } from "next/navigation";
import Checkbox from "@/components/ui/Checkbox";
import Link from "next/link";
import { useSelector, useDispatch } from "react-redux";
import { handleLogin } from "./store";
import { toast } from "react-toastify";
import { AjaxPostAnon } from "@/util/Ajax";
import md5 from "md5";
import useAuthInfo from "@/store/auth";
import GoogleSignIn from "./google-sign-in";
const schema = yup
  .object({
    email: yup.string().email("Invalid email").required("Email is Required"),
    password: yup.string().required("Password is Required"),
  })
  .required();
const LoginForm = ({onSuccess = null}) => {
  const authData = useAuthInfo((state) => state);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
    //
    mode: "all",
  });
  const router = useRouter();

  const onSubmit = async (data) => {
    var res = await AjaxPostAnon(`Authentication/Login`, {
      email: data.email,
      passwordHash: md5(data.password),
    });
    if (res.data) {
      authData.updateAuthStore(res.data);
      if(onSuccess != null){
        return onSuccess();
      }
      setTimeout(() => {
        router.push("/");
      }, 1500);
    } else {
      toast.error("Invalid credentials", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const onGoogleAuthenticated = (data) => {
    authData.updateAuthStore(data);
    if (onSuccess != null) {
      onSuccess();
      return;
    }
    router.push("/");
  };

  const [checked, setChecked] = useState(false);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 ">
      <GoogleSignIn
        onAuthenticated={onGoogleAuthenticated}
        text="signin_with"
      />
      <Textinput
        name="email"
        label="email"
        defaultValue=""
        type="email"
        placeholder="Email"
        register={register}
        error={errors?.email}
      />
      <Textinput
        name="password"
        label="password"
        type="password"
        placeholder="Password"
        defaultValue=""
        register={register}
        error={errors.password}
      />
      <div className="flex justify-between">
        <Checkbox
          value={checked}
          onChange={() => setChecked(!checked)}
          label="Keep me signed in"
        />
        <Link
          href="/forgot-password"
          className="text-sm text-slate-800 dark:text-slate-400 leading-6 font-medium"
        >
          Forgot Password?{" "}
        </Link>
      </div>

      <button className="btn btn-dark block w-full text-center">Sign in</button>
    </form>
  );
};

export default LoginForm;
